import React from 'react';

export default class ReadMoreFade extends React.Component {
    constructor(props) {
        super(props);

        var cachedValue = localStorage ? localStorage.getItem(`ReadMoreFade.${this.props.cacheKey}`) : null;
        
        this.state = {
            showMore: cachedValue && cachedValue === 'true' ? cachedValue : false
        };
    }

    showMoreStyles() {
        return {position: 'relative', marginBottom: 35};
    }

    showLessStyles() {
        return {maxHeight: 120, position: 'relative', overflow: 'hidden'};
    }

    toggle(e) {
        e.preventDefault();
        this.setState({showMore: !this.state.showMore}, () => {
            localStorage.setItem(`ReadMoreFade.${this.props.cacheKey}`, this.state.showMore);
        });
    }

    linkStyle() {
        return this.state.showMore ? {
            position: 'absolute',
            bottom: -30,
            left: 0,
            width: '100%',  
            textAlign: 'center',
        } : {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            margin: 0,
            textAlign: 'center',
            backgroundImage: 'linear-gradient(to bottom, transparent, white)'
        };
    }

    render() {
        return (
            <div>
                <div style={this.state.showMore ? this.showMoreStyles() : this.showLessStyles()}>
                    {this.props.children}
                    <div style={this.linkStyle()}></div>
                </div>
                <a href='#' onClick={(e) => this.toggle(e)} style={{ display: 'block', width: '100%', textAlign: 'center'}}>
                    {this.state.showMore ? 'Show Less' : 'Read More'}
                </a>
            </div>
        );
    }
}